/* eslint-disable import/prefer-default-export */
import client from 'core/axios';
import handleError from 'core/axios/handleError';
import { handleJSONResponse } from 'core/axios/handleResponse';
import RequestMethod from 'core/axios/RequestMethod';

export const getVirtualTours = ({ version = 'v1', params = {} } = {}) =>
  client
    .request({
      url: `${version}/virtual-workplace-tours/virtual-workspaces/`,
      method: RequestMethod.GET,
      params,
    })
    .then(handleJSONResponse)
    .catch(handleError);
